// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__gT4Rc","title":"Images45_title__2dbzA","images":"Images45_images__2YGSc"};